"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchOrUpdateConsents = exports.closeModal = exports.changePassword = exports.updateUserEmail = exports.updateUserCompany = exports.fetchCustomers = exports.removeUser = exports.resetPassword = exports.resendAuthenticationCode = exports.updateMemberInfo = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const redux_observable_1 = require("redux-observable");
const errorHandling_1 = require("../../utils/errorHandling");
const ActionTypes = require("../../actionTypes/user/userSettings");
const Actions = require("../../actions/user/userSettings");
const sok_types_1 = require("@caddigital/sok-types");
const userValidation_1 = require("../../utils/userValidation");
const status_1 = require("../../status");
function updateMemberInfo(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.UPDATE_MEMBER_INFO_REQUEST), (0, operators_1.mergeMap)((_action) => {
        const userSettings = store.value.user.userSettings;
        const data = Object.assign(Object.assign({}, userSettings.userInfo), { email: userSettings.user.map((x) => x.email).getOrElse('') });
        const id = userSettings.user.map((x) => x.id).getOrElse(NaN);
        const validation = (0, userValidation_1.validateUserInformation)(data);
        return validation.fold((e) => (0, rxjs_1.of)(Actions.updateMemberInfoValidation(e)).pipe((0, operators_1.delay)(500)), (x) => ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'PATCH',
            url: `${baseUrl}api/auth/user/${id}`,
            body: data
        }).pipe((0, operators_1.mergeMap)((res) => {
            const actions = [
                Actions.updateMemberInfoSuccess(res.response)
            ];
            return (0, rxjs_1.of)(...actions);
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.updateMemberInfoFailure((0, errorHandling_1.parseAjaxErrorResponse)(error))))));
    }));
}
exports.updateMemberInfo = updateMemberInfo;
function resendAuthenticationCode(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.RESEND_AUTHENTICATION_CODE_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/auth/resend-verification`,
        body: {
            email: action.payload.email
        }
    }).pipe((0, operators_1.mergeMap)(() => {
        return (0, rxjs_1.of)(Actions.resendAuthenticationCodeSuccess());
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.resendAuthenticationCodeFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.resendAuthenticationCode = resendAuthenticationCode;
function resetPassword(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.RESET_PASSWORD_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/admin/user/${action.payload.id}/password`,
        body: {
            email: action.payload.email,
            language: action.payload.language
        }
    }).pipe((0, operators_1.mergeMap)(() => {
        return (0, rxjs_1.of)(Actions.resetPasswordSuccess());
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.resetPasswordFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.resetPassword = resetPassword;
function removeUser(action$, _store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.REMOVE_USER_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'DELETE',
        url: `${baseUrl}api/admin/user/${action.payload}`
    }).pipe((0, operators_1.mergeMap)(() => {
        return (0, rxjs_1.of)(Actions.removeUserSuccess());
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.removeUserFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.removeUser = removeUser;
function fetchCustomers(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_CUSTOMERS), (0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/customer/search/${payload.name}`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validate = t
            .array(t.interface({
            businessId: t.string,
            name: t.string,
            id: t.number
        }))
            .decode(response);
        const act = validate.fold((e) => Actions.fetchCustomersFailed((0, errorHandling_1.parseValidationError)(e)), (c) => {
            return Actions.fetchCustomersSuccess(c);
        });
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchCustomersFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.fetchCustomers = fetchCustomers;
function updateUserCompany(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.UPDATE_USER_COMPANY), (0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: payload,
        url: `${baseUrl}api/admin/user/update-user-company`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validate = sok_types_1.User.iUser.decode(response);
        const act = validate.fold((e) => Actions.updateUserCompanyFailure((0, errorHandling_1.parseValidationError)(e)), () => {
            return Actions.updateUserCompanySuccess();
        });
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.updateUserCompanyFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.updateUserCompany = updateUserCompany;
function updateUserEmail(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.UPDATE_EMAIL), (0, operators_1.mergeMap)((action) => {
        const settings = store.value.user.userSettings;
        const user = settings.user.map((u) => u.uuid).getOrElse('');
        const body = { user, newEmail: settings.newEmail };
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'PUT',
            body: body,
            url: `${baseUrl}api/admin/user/change-email`
        }).pipe((0, operators_1.mergeMap)(({ response }) => {
            const validate = t
                .interface({
                message: t.string
            })
                .decode(response);
            const act = validate.fold((e) => Actions.updateEmailFailure((0, errorHandling_1.parseValidationError)(e)), () => {
                return Actions.updateEmailSuccess();
            });
            return (0, rxjs_1.of)(act);
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.updateEmailFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
    }));
}
exports.updateUserEmail = updateUserEmail;
function changePassword(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CHANGE_PASSWORD_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/auth/change-password`,
        body: action.payload
    }).pipe((0, operators_1.mergeMap)(() => {
        return (0, rxjs_1.of)(Actions.changePasswordSuccess());
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.changePasswordFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.changePassword = changePassword;
function closeModal(action$, _store, _opts) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CLOSE_USER_SETTINGS_MODAL), (0, operators_1.mergeMap)((action) => (0, rxjs_1.of)(...action.payload)));
}
exports.closeModal = closeModal;
const fetchOrUpdateConsents = (action$, _store, { ajax, getToken, baseUrl }) => {
    const ajaxOptions = ({ userId, consents }) => ({
        method: consents ? 'PATCH' : 'GET',
        url: `${baseUrl}api/user/${userId}/consents`,
        headers: {
            Authorization: getToken(),
            'Content-Type': 'application/json'
        },
        body: consents
    });
    const ajaxCall = (payload) => {
        const reqType = payload.consents ? status_1.RequestType.UPDATE : status_1.RequestType.FETCH;
        return ajax(ajaxOptions(payload)).pipe((0, operators_1.map)((response) => Actions.fetchOrUpdateUserConsentsSuccess(reqType, response.response)), (0, operators_1.catchError)((error) => {
            const responseError = (0, errorHandling_1.parseAjaxErrorResponse)(error);
            return (0, rxjs_1.of)(Actions.fetchOrUpdateUserConsentsFailure(reqType, responseError));
        }));
    };
    return action$.pipe((0, redux_observable_1.ofType)(ActionTypes.FETCH_OR_UPDATE_USER_CONSENTS_REQUEST), (0, operators_1.mergeMap)(({ payload }) => ajaxCall(payload)));
};
exports.fetchOrUpdateConsents = fetchOrUpdateConsents;
//# sourceMappingURL=userSettings.js.map